import { Mic } from "lucide-react";
import { INTERVIEW_GROUPS } from "@/data/content";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

export default function Interviews() {
  return (
    <section id="interviews" data-testid="interviews-section" className="border-y border-atlantic/10 bg-sand-dark py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <SectionHeading
              chapter="08"
              kicker="Atlantic Interviews"
              title="The People Shaping the Relationship"
              copy="Conversations with the citizens and leaders shaping Africa–Caribbean relations — in their own words."
            />
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
              {INTERVIEW_GROUPS.map((g, i) => (
                <Reveal key={g} delay={i * 0.06}>
                <div
                  data-testid={`interview-group-${g.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="group flex aspect-square flex-col justify-between border border-atlantic/10 bg-white p-5 transition-colors hover:border-gold"
                >
                  <Mic size={18} className="text-ocean transition-colors group-hover:text-gold" />
                  <p className="font-serif text-base leading-snug text-atlantic sm:text-lg">{g}</p>
                </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
